import { queryOptions, useQuery } from '@tanstack/react-query';
import { ItemTypeLevelApi } from '@/common/api/itemTypeLevel';
import { commonQueryKeys } from '@/common/queryKeys/common';

export const itemTypeLevelQueryOptions = (levelId: number) =>
  queryOptions({
    queryKey: commonQueryKeys.itemTypeLevels.details(levelId),
    queryFn: () =>
      ItemTypeLevelApi.getItemTypeLevel({
        levelId,
      }),
  });

export const useItemTypeLevelQuery = ({
  levelId,
  enabled = true,
}: {
  levelId: number;
  enabled?: boolean;
}) => {
  return useQuery({ ...itemTypeLevelQueryOptions(levelId), enabled });
};
